import { sendGet, sendPut } from './../helpers/axios';
import { sendGet as sendGetBwf } from './../helpers/axiosBwf';

export const apiGetInforUser = (params) => sendGet('/api/user/' + params.user_id);
export const apiUpdateInforUser = (userId, params) => sendPut('/api/user/' + userId, params);
export const apiGetPermissionUserInBo = (userId) => sendGet(`/api/user/permission/${userId}`);
export const apiGetPermissionUserInWorkFollow = (userId) => sendGetBwf('/api/v1/hr-user-permission', userId);
